import script from "./GreetingsHolder.vue?vue&type=script&setup=true&lang=ts"
export * from "./GreetingsHolder.vue?vue&type=script&setup=true&lang=ts"

import "./GreetingsHolder.vue?vue&type=style&index=0&id=cd05928c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd05928c"]])

export default __exports__